<template>
  <v-chip
    label
    outlined
    color="indigo"
    :to="{ name: 'RawMaterials', params: { id: rawmaterial.material_id } }"
  >
    <v-icon left>
      grain
    </v-icon>
    {{ rawmaterial.barcode }}
  </v-chip>
</template>

<script>
export default {
  name: "RawMaterialChip",
  props: {
    rawmaterial: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
};
</script>
